import Modal from "../General/Modal"

const FeeInfoModal = ({setShowFeeInfoModal}: {setShowFeeInfoModal: (show: boolean) => void}) => {

  const headingClass = "text-center bg-my-olive text-white text-md uppercase p-2 border border-my-grey border-b-0"
  const subHeadingClass = "text-left bg-my-olive text-white capitalize p-1 border border-my-grey font-normal"
  const cellClass = "p-1 border border-my-grey text-left"

  return <Modal
    closeFunction={() => setShowFeeInfoModal(false)}
    title="Who pays the fees?"
  >
    <>
      <p className="py-2 text-left">Flossi apply small service / convenience fees to each payment.</p>
      <table className="w-full max-w-md mx-auto text-xs my-2">
        <thead>
          <tr>
            <th colSpan={4} scope="col" className={`${headingClass}`}>
              Service / Convenience Fees
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={2} className={`${subHeadingClass}`}>
              Payment Amount
            </td>
            <td className={`${subHeadingClass}`}>
              Service Fee
            </td>
            <td className={`${subHeadingClass} break-normal`}>
              Convenience Fee
            </td>
          </tr>
          <tr>
            <td className={`${cellClass} border-t-0`} colSpan={2}>
              Less than £2
            </td>
            <td className={`${cellClass} border-t-0`}>
              -
            </td>
            <td className={`${cellClass} border-t-0`}>
              £0.20
            </td>
          </tr>
          <tr>
            <td className={`${cellClass} border-t-0`} colSpan={2}>
              From £2 to £3000
            </td>
            <td className={`${cellClass}`}>
              1%
            </td>
            <td className={`${cellClass}`}>
              £0.20
            </td>
          </tr>
        </tbody>
      </table>
      <p className="py-2 text-left">As the jar owner, <span className="font-bold">you can choose</span> if you or the contributor will pay the fees. The following £10 payment example presents your options.</p>
      <h1 className="underline text-left font-bold">Option 1 - Jar Owner Pays Fees</h1>
      <p className="text-left">
        The fees are taken from the total contribution amount and are therefore paid for by the jar owner.
      </p>
      <ul className="text-left py-2">
        <li>Contributor Pays: £10.00</li>
        <li>Jar Owner Receives: £9.70 <span className="text-sm">(£10.00 minus £0.30 fees)</span></li>
      </ul>
      <h1 className="underline text-left font-bold">Option 2 - Contributor Pays Fees</h1>
      <p className="text-left">The fees are added to the contribution amount and are therefore paid for by the contributor.</p>
      <ul className="text-left py-2">
        <li>Contributor Pays: £10.30 <span className="text-sm">(£10.00 plus £0.30 fees)</span></li>
        <li>Jar Owner Receives: £10.00</li>
      </ul>
    </>
  </Modal>
}

export default FeeInfoModal